import { fetchNotifications } from "@api/notifications/notifications";
import { NotificationResponseType } from "@type/notifications/notifications";
import { useEffect, useState } from "react";

interface UseNotifications {
  notifications: NotificationResponseType;
  error: any;
  handleQuery: (key: string, value: number | boolean | string | null) => void;
}

type InitialQueries = {
  isRead?: boolean;
};

export const useNotifications = (
  initialQueries?: InitialQueries,
): UseNotifications => {
  const [notifications, setNotifications] = useState(
    {} as NotificationResponseType,
  );
  const [error, setError] = useState();
  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
    ...initialQueries,
  });
  const handleQuery = (key: string, value: number | boolean | string | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));
  useEffect(() => {
    fetchNotifications(query)
      .then((res) => {
        setNotifications(res.data);
      })
      .catch((err) => {
        setError(err);
      });
  }, [query]);

  return {
    notifications,
    error,
    handleQuery,
  };
};
